import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private router: Router
  ) {}

  canActivate(): Observable<boolean> {
    console.log('MusicServed: AuthGuard checking auth status');
    return this.authService.checkAuthStatus().pipe(
      take(1),
      map(isAuthenticated => {
        console.log('MusicServed: AuthGuard result:', isAuthenticated);
        if (isAuthenticated) {
          return true;
        } else {
          console.log('MusicServed: AuthGuard redirecting to login');
          this.router.navigate(['/auth/login'], { replaceUrl: true });
          return false;
        }
      })
    );
  }
}